import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kooperationspartner',
  templateUrl: './kooperationspartner.component.html',
  styleUrls: ['./kooperationspartner.component.scss']
})
export class KooperationspartnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
